class SalonDetails {
    salon;
    constructor(container, googleApiKey) {
        this.container = container;
        this.googleApiKey = googleApiKey;
        this.heroBannerSection = this.container.querySelector("[salon-details-hero]");
        this.detailsInfoSection = this.container.querySelector("[salon-details-data]");
        this.mapSection = this.container.querySelector("[salon-details-map]");
    }
    async init() {
        this.salon = await this.getSalon();
        if (this.salon != null) {
            this.setHeroBannerData();
            this.setDetailsInfoData();
            this.setStaticMap();
        }
        this.removeOverlay(this.container.querySelector("[salon-details-overlay]"));
    }
    async getSalon() {
        const url = new URL(window.location.href),
            salonId = url.searchParams.get("id"),
            salonDistance = url.searchParams.get("distance");
        if (salonId != null) {
            const params = new URLSearchParams({
                id: salonId,
                division: middleware["salonsLocator"]["division"],
                page: 1,
                rows: 1
            });

            return await fetch(`${middleware["salonsLocator"]["apiUrl"]}/salons?${params}`)
                .then((response) => {
                    if (response.ok) return response.json();
                    return Promise.reject("Wrong fetch");
                })
                .then(async (data) => {
                    const salon = data.rows.length === 1 ? new Salon(data.rows[0], salonDistance) : null;
                    salon && await salon.getSalonGMBData();
                    return Promise.resolve(salon);
                })
                .catch((error) => console.debug("Something went wrong.", error));
        }
        return null;
    }
    setStaticMap() {
        if (this.mapSection != null) {
            const centerCoords = new google.maps.LatLng(this.salon.latitude, this.salon.longitude);

            this.mapSection = new google.maps.Map(this.mapSection, {
                zoom: 18,
                center: centerCoords,
                zoomControl: false,
                disableDefaultUI: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                gestureHandling: "greedy",
                styles: this.salon.mapStyles
            });
            new google.maps.Marker({
                position: { lat: this.salon.latitude, lng: this.salon.longitude },
                map: this.mapSection,
                title: this.salon.title,
                icon: this.salon.typeIcons[this.salon.type]
            });
        }
    }
    setHeroBannerData() {
        if (this.heroBannerSection != null) {
            var servicesImages = '';
            this.salon.services.forEach((service) => {
                if (!this.salon.servicesEnabled.includes(service)) return;
                servicesImages += '<img class="salon-service-img" alt="dav icon" src="' + this.salon.servicesIcons[service].url + '">';
            });

            let dataBannerHtml = this.heroBannerSection.innerHTML;
            dataBannerHtml = dataBannerHtml.replaceAll("##NAME##", this.salon.businessname != null ? this.salon.businessname : this.salon.name);
            dataBannerHtml = dataBannerHtml.replace("##TYPE##", this.salon.type != null ? this.salon.type : "");
            dataBannerHtml = dataBannerHtml.replace("##LOGO##", this.salon.profilePhoto != null ? this.salon.profilePhoto : `${middleware["salonsLocator"]["svg"]["defaultLogo"]}`);
            dataBannerHtml = dataBannerHtml.replace("##ICONS##", servicesImages);
            this.salon.profilePhoto != null && this.heroBannerSection.classList.add("custom-salon-image");
            if (this.salon.coverPhoto != null) this.heroBannerSection.style.backgroundImage = `url('${this.salon.coverPhoto}')`;
            this.heroBannerSection.innerHTML = dataBannerHtml;
        }
    }
    setDetailsInfoData() {
        if (this.detailsInfoSection != null) {
            this.initOpenLegend();
            this.salon.createDetailsData(this.detailsInfoSection);
            this.initOpenWeekDay();
        }
    }
    initOpenLegend() {
        let self = this;
        const legendWrapper = self.container.querySelector(".salon-details__wrapper-legend");
        if (legendWrapper != null) {
            legendWrapper.addEventListener("click", () => {
                legendWrapper.classList.toggle("open");
                self.container.querySelector(".salon-details__legend-content").classList.toggle("active");
            });
        }
    }
    initOpenWeekDay() {
        let self = this;
        const weekDayWrapper = self.container.querySelector(".salon-details__wrapper-weekday");
        if (weekDayWrapper != null) {
            weekDayWrapper.addEventListener("click", () => {
                weekDayWrapper.classList.toggle("open");
                self.container.querySelector(".salon-details__weekday-content").classList.toggle("active");
            });
        }
    }
    removeOverlay(overlay) {
        if (overlay === null) return;
        overlay.classList.add("overlay-data");
    }
}

class Salon {
    address;
    name;
    businessname;
    city;
    country;
    distance;
    icon;
    id;
    latitude;
    longitude;
    mail;
    #placeId;
    region;
    social;
    type;
    website;
    zipcode;
    phone_number;
    typeIcons = {
        "davines salon": middleware["salonsLocator"]["svg"]["davinesPin"],
        "sustainable beauty partner": middleware["salonsLocator"]["svg"]["multibrandPin"]
    };
    mapStyles = [
        { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
        { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
        { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
        { elementType: "labels.text.stroke", stylers: [{ color: "#f5f5f5" }] },
        { featureType: "administrative.land_parcel", elementType: "labels", stylers: [{ visibility: "off" }] },
        { featureType: "administrative.land_parcel", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
        { featureType: "landscape.man_made", stylers: [{ color: "#8a8a8a" }] },
        { featureType: "landscape.man_made", elementType: "geometry.fill", stylers: [{ color: "#dfddde" }] },
        { featureType: "landscape.natural", elementType: "geometry.fill", stylers: [{ color: "#78b64b" }, { saturation: -70 }, { lightness: 70 }] },
        { featureType: "landscape.natural.landcover", elementType: "geometry.fill", stylers: [{ color: "#dfddde" }] },
        { featureType: "poi", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
        { featureType: "poi", elementType: "labels.text", stylers: [{ visibility: "off" }] },
        { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
        { featureType: "poi.park", stylers: [{ visibility: "on" }] },
        { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
        { featureType: "poi.park", elementType: "geometry.fill", stylers: [{ color: "#78b74b" }, { saturation: -65 }, { lightness: 40 }] },
        { featureType: "poi.park", elementType: "labels.icon", stylers: [{ color: "#78b74b" }, { saturation: -45 }, { lightness: 35 }, { visibility: "off" }] },
        { featureType: "poi.sports_complex", elementType: "geometry.fill", stylers: [{ color: "#78b74b" }, { saturation: -65 }, { lightness: 40 }] },
        { featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
        { featureType: "road.arterial", elementType: "geometry.fill", stylers: [{ color: "#bdbdbd" }] },
        { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ visibility: "off" }] },
        { featureType: "road.arterial", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
        { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#dadada" }] },
        { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#ffffff" }] },
        { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
        { featureType: "road.local", elementType: "geometry.fill", stylers: [{ color: "#ededed" }] },
        { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ color: "#d1d1d1" }, { saturation: -15 }, { lightness: 60 }, { visibility: "simplified" }] },
        { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "off" }] },
        { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
        { featureType: "transit.line", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
        { featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
        { featureType: "water", elementType: "geometry", stylers: [{ color: "#c9c9c9" }] },
        { featureType: "water", elementType: "geometry.fill", stylers: [{ color: "#cde5fe" }, { saturation: -50 }, { lightness: -10 }] },
        { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] }
    ];
    servicesIcons = {
        color: { url: middleware["salonsLocator"]["svg"]["colorWhite"] },
        treatment: { url: middleware["salonsLocator"]["svg"]["treatmentWhite"] },
        styling: { url: middleware["salonsLocator"]["svg"]["stylingWhite"] }
    };
    servicesEnabled = middleware["salonsLocator"]["services"].split(",");
    constructor(salon, distance) {
        this.address = this.#setField(salon.address);
        this.businessname = this.#setField(salon.businessname);
        this.city = this.#setField(salon.city);
        this.country = this.#setField(salon.country);
        this.distance = distance;
        this.id = this.#setField(salon.id);
        this.latitude = this.#setField(salon.latitude);
        this.longitude = this.#setField(salon.longitude);
        this.mail = this.#setField(salon.mail);
        this.name = this.#setField(salon.name);
        this.#placeId = this.#setField(salon.place_id);
        this.region = this.#setField(salon.region);
        this.type = this.#setField(salon.type);
        this.website = this.#setField(salon.website);
        this.zipcode = this.#setField(salon.zipcode);
        this.phone_number = this.#setField(salon.telephone);
        this.services = salon.service ? salon.service.split(",") : [];
    }
    #setField(field) {
        return field === "" || field == null ? null : field;
    }
    async getSalonGMBData() {
        if (this.#placeId == null) return;
        const lang = document.documentElement.lang || "en";

        const response = await fetch(`${middleware["salonsLocator"]["apiUrl"]}/salons/details?place_id=${this.#placeId}&callSentric=true&callGooglePlaces=true&language=${lang}`);
        if (!response.ok) throw new Error(response.status);
        const placeDetails = await response.json();

        this.#mapPlaceDetailsFields(placeDetails);
    }
    #mapPlaceDetailsFields(placeDetails) {
        this.gmbUrl = this.#setField(placeDetails.url);
        this.social = this.#setField(placeDetails.website || this.website);
        this.name = this.#setField(placeDetails.name || this.name);
        this.phone_number = this.#setField(placeDetails.formatted_phone_number || this.phone_number);
        this.address = placeDetails.formatted_address || this.address;
        this.open = placeDetails.current_opening_hours != null ? placeDetails.current_opening_hours?.open_now : (placeDetails.opening_hours != null ? placeDetails.opening_hours?.open_now : null);
        this.closingTime = placeDetails.current_opening_hours != null ? this.#getClosingTime(placeDetails.current_opening_hours) : this.#getClosingTime(placeDetails.opening_hours);
        this.stringWeekday = placeDetails.current_opening_hours != null ? this.#getStringWeekday(placeDetails.current_opening_hours) : this.#getStringWeekday(placeDetails.opening_hours);
        this.description = this.#setField(placeDetails.description);
        this.photo = this.#setField(placeDetails.photos?.photo_reference);
        this.profilePhoto = this.#setField(placeDetails.images?.profilePhoto?.fullImageUrl);
        this.coverPhoto = this.#setField(placeDetails.images?.coverPhoto?.fullImageUrl);
        this.serviceItems = placeDetails.serviceItems && placeDetails.serviceItems.length > 0 ? placeDetails.serviceItems : null;
    }
    #getClosingTime(opening_hours) {
        if (opening_hours == null || opening_hours?.periods == null || opening_hours?.periods.length === 0) return null;
        const d = new Date(),
            day = d.getDay();
        const currentDay = opening_hours?.periods.filter(element => element?.close?.day === day);
        return currentDay.length > 0 ? `| ${middleware["salonsLocator"]["labels"]["closeAt"]} ${(parseFloat(currentDay[0]?.close?.time) / 100).toFixed(2).replace(".", ":")}` : null;
    }
    #getStringWeekday(opening_hours) {
        let weekDayOpen = opening_hours?.weekday_text;
        return weekDayOpen != null && weekDayOpen.length > 0 ? weekDayOpen.join("<br>") : null;
    }
    createDetailsData(detailsInfoSection) {
        this.#createDetailsDescription(detailsInfoSection);
        this.#createDetailsBlockInfo(detailsInfoSection);
        this.#createDetailsBlockContacts(detailsInfoSection);
        this.#createDetailsBlockServices(detailsInfoSection);
    }
    #createDetailsDescription(detailsInfoSection) {
        if (this.description == null) return;

        const detailsDescriptionSalon = detailsInfoSection.querySelector("[salon-details-description]");
        if (detailsDescriptionSalon != null) {
            detailsDescriptionSalon.innerHTML = `<div>"${this.description}"</div>`;
        }
    }
    #createDetailsBlockInfo(detailsInfoSection) {
        const detailsBlockInfo = detailsInfoSection.querySelector("[details-block-info]");
        if (detailsBlockInfo != null) {
            detailsBlockInfo.innerHTML = `<div class="salon-details__info-icon">
                <img class="" alt="dav icon" src="${this.typeIcons[this.type]}">
            </div>
            <div class="salon-details__info-wrapper">
                <div class="salon-details__info-content">
                    <span class="salon-details__block-text">${this.address},</span>
                    <span class="salon-details__block-text">${this.zipcode} ${this.city}${this.region !== null ? `, ${this.region}` : ""}</span>
                    ${this.distance != null ? `<span class="salon-details__block-text salon-details__block-address">${this.distance} km</span>` : ""}
                </div>
                ${this.open != null ? `<div class="salon-details__block-text">
                ${this.open != false ? `<span class="salon-details__green-text">${middleware["salonsLocator"]["labels"]["open"]}</span>` : `${middleware["salonsLocator"]["labels"]["close"]}`} ${this.closingTime != null ? this.closingTime : ""}</div>` : ""}
                ${this.stringWeekday != null ? `<div class="salon-details__block-text salon-details__show-more">
                    <div class="salon-details__wrapper-weekday">
                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="10" viewBox="0 0 9 10">
                            <path id="Tracciato_180" data-name="Tracciato 180" d="M5,0l5,9H0Z" transform="translate(9) rotate(90)" fill="#4e4b4a"/>
                        </svg>
                        <span>${middleware["salonsLocator"]["labels"]["showTime"]}</span>
                    </div>
                    <div class="salon-details__weekday-content">
                        <div>${this.stringWeekday}</div>
                    </div>
                </div>` : ""}

                ${this.latitude != null && this.longitude != null ? `<div class="direction-button-wrapper" get-directions>
                    <a class="btn-primary cta-width salon-details__info-btn" href="https://www.google.com/maps/dir/?api=1&destination=${this.latitude},${this.longitude}" target="_blank" onclick="datalayerEvents.detailsLinkClick('get-directions', '${this.name}', '${this.type}')">
                        <svg id="Raggruppa_356" data-name="Raggruppa 356" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18.786" height="20" viewBox="0 0 18.786 20">
                            <path id="Tracciato_215" data-name="Tracciato 215" d="M18.281,12.694a88.183,88.183,0,0,0-7.793-4.538l-.136-.073a2.487,2.487,0,0,0-.661.42c-.1.079-.211.161-.313.233.112.161.219.33.322.5a3.463,3.463,0,0,0,.988,1.177,24.846,24.846,0,0,0,2.93,1.431c.409.178.832.362,1.243.552l.648.3-.712.049a96.3,96.3,0,0,1-10.446.2c-1.045-.041-3.221-.126-3.208-2.613.006-1.115-.019-2.25-.044-3.347-.018-.8-.036-1.629-.042-2.444-.011-1.528.633-2.385,1.915-2.547.306-.039.613-.082.92-.124A19.7,19.7,0,0,1,7.4,1.591c1.783.074,3.591.214,5.339.349,1.511.117,3.074.237,4.611.315.241.011.542-.223.834-.451.1-.081.208-.163.314-.238-.065-.119-.129-.249-.191-.376C18.2.966,17.97.5,17.859.489Q16.587.421,15.314.346C11.668.136,7.9-.081,4.2.029.581.138.449.471.135,4.038.017,5.384.025,6.767.033,8.105c.005.912.011,1.855-.024,2.782-.095,2.557.6,3.345,3.082,3.511,1.586.106,3.2.146,4.769.185.836.021,1.7.042,2.552.073.978.036,1.972.086,2.932.135l1.318.066.148.007.145.892-.105.064c-.368.224-.748.444-1.115.657a22.041,22.041,0,0,0-2.707,1.748c-.233.186-.3.666-.364,1.131-.023.164-.046.331-.077.491.1.018.211.041.315.063.31.067.661.142.8.042,1.2-.881,2.4-1.819,3.552-2.726.916-.72,1.864-1.464,2.812-2.176a1.636,1.636,0,0,0,.72-1.346,1.258,1.258,0,0,0-.5-1.01" transform="translate(-0.001 0)" fill="#fff"/>
                        </svg>
                        <span class="btn-primary__text">${middleware["salonsLocator"]["labels"]["direction"]}</span>
                    </a>
                </div>` : ""}
            </div>`;
        }
    }
    #createDetailsBlockContacts(detailsInfoSection) {
        if (this.phone_number == null && this.mail == null && this.website == null && this.social == null && this.gmbUrl == null) {
            detailsInfoSection.querySelector("[details-block-contacts]") && detailsInfoSection.querySelector("[details-block-contacts]").remove();
            return;
        }
        const detailsBlockContacts = detailsInfoSection.querySelector("[details-contacts]");
        if (detailsBlockContacts != null) {
            detailsBlockContacts.innerHTML = `
                <div class="salon-details__block-wrapper">
                ${this.phone_number != null ? `<div class="salon-details__block-wrap" details-tel>
                    <a class="salon-details__block-wrap" href="tel:${this.phone_number}" onclick="datalayerEvents.detailsLinkClick('details-tel', '${this.name}', '${this.type}')">
                        <img src="${middleware["salonsLocator"]["svg"]["callUs"]}" alt="callUs" class=""/>
                        <span class="salon-details__block-text">${this.phone_number}</span>
                    </a>
                </div>` : ""}
                ${this.mail != null ? `<div class="salon-details__block-wrap" details-mail>
                    <a class="salon-details__block-wrap" href="mailto:${this.mail}" onclick="datalayerEvents.detailsLinkClick('details-mail', '${this.name}', '${this.type}')">
                        <img src="${middleware["salonsLocator"]["svg"]["emailUs"]}" alt="mailUs" class=""/>
                        <span class="salon-details__block-text">${this.mail}</span>
                    </a>
                </div>` : ""}
                ${this.website != null ? `<div class="salon-details__block-wrap" details-website>
                    <a class="salon-details__block-wrap" href="${this.website}" onclick="datalayerEvents.detailsLinkClick('details-website', '${this.name}', '${this.type}')">
                        <img src="${middleware["salonsLocator"]["svg"]["website"]}" alt="website" class=""/>
                        <span class="salon-details__block-text">${this.website}</span>
                    </a>
                </div>` : ""}
                ${this.social != null ? `<div class="salon-details__block-wrap" details-social>
                    <a class="salon-details__block-wrap" href="${this.social}" onclick="datalayerEvents.detailsLinkClick('details-social', '${this.name}', '${this.type}')">
                        <img src="${middleware["salonsLocator"]["svg"]["social"]}" alt="social" class=""/>
                        <span class="salon-details__block-text">${this.social}</span>
                    </a>
                </div>` : ""}
                ${this.gmbUrl != null ? `<div class="salon-details__block-wrap" details-gmb>
                    <a class="salon-details__block-wrap" href="${this.gmbUrl}" target="_blank" onclick="datalayerEvents.detailsLinkClick('details-gmb', '${this.name}', '${this.type}')">
                        <img src="${middleware["salonsLocator"]["svg"]["gmbIcon"]}" alt="gmb" class=""/>
                        <span class="salon-details__block-text">${middleware["salonsLocator"]["labels"]["gmb"]}</span>
                    </a>
                </div>` : ""}
            </div>`;
        }
    }
    #createDetailsBlockServices(detailsInfoSection) {
        if (this.serviceItems == null) {
            detailsInfoSection.querySelector("[details-block-services]") && detailsInfoSection.querySelector("[details-block-services]").remove();
            return;
        }
        const detailsBlockServices = detailsInfoSection.querySelector("[details-services]");
        if (detailsBlockServices != null) {
            detailsBlockServices.innerHTML = this.serviceItems.map((service) => {
                return service.description != null ? (`<p class="salon-details__block-service">
                    ${service.description} ${service.price != null ? `${service.price}${service.currencyCode}` : ""}
                </p>`) : "";
            }).join("");
        }
    }
}

class DatalayerEvents {
    constructor() { }

    detailsLinkClick(action, name, type) {
        if (typeof dataLayer != "undefined") {
            dataLayer.push({
                event: "GAevent",
                ss_event_id: GTM.getGtmRandomString(),
                eventID: "53",
                eventCategory: "store_locator_page",
                eventAction: GTM.formatString(action),
                eventLabel: GTM.formatString(name),
                storeType: GTM.formatString(type)
            });
        }
    }
}
